import { ColumnTypeEnum } from '@y42/json-schema';

export class TextExtractionModel {
  constructor(public target = '', public source = '', public conditions: TextExtractionCondition[] = []) {}
}

export class TextExtractionCondition {
  constructor(
    public operation: 'AFTER' | 'BEFORE' = 'AFTER',
    public matchCondition: 'FIRST' | 'LAST' = 'FIRST',
    public valueType: ColumnTypeEnum.String | ColumnTypeEnum.Numeric = ColumnTypeEnum.Numeric,
    public valueOrOffset: string | number = 0,
  ) {}
}
